import httpManager from "@/app/shared/utils/httpManager";

export async function updateLoggedUser(profile) {
  const { data } = await httpManager.get("/users/data/");
  const response = await httpManager.uploadPut(`/users/${data.id}/`, profile);
  return response.data;
}
